import { useNavigate, useParams } from 'react-router-dom';

import { Button, Modal } from 'antd';

import { enStatus } from '@/interfaces/course';
import { useAcceptTermMutation, useGetCourseQuery } from '@/services/course';
import styled, { StyledProp } from '@/styled';

const CourseTerm = (props: StyledProp) => {
  const { hash } = useParams();
  const { data } = useGetCourseQuery(hash);
  const navigate = useNavigate();
  const [saveDecision, { isLoading }] = useAcceptTermMutation();

  const acceptTerm = () => {
    saveDecision({ courseHash: hash, accepted: true });
  };

  const refuseTerm = () => {
    saveDecision({ courseHash: hash, accepted: false });
    navigate('/resumo');
  };

  return (
    <Modal
      aria-label='Termos de aceite do curso'
      open={data?.status === enStatus.MUST_ACCEPT_TERM}
      title='Termos e condições de Uso'
      closable={false}
      footer={
        <>
          <Button type='text' onClick={refuseTerm} disabled={isLoading}>
            Discordo
          </Button>
          <Button type='primary' onClick={acceptTerm} loading={isLoading}>
            Concordo
          </Button>
        </>
      }
    >
      <div className={props.className} dangerouslySetInnerHTML={{ __html: data?.terms_content }} />
    </Modal>
  );
};
export default styled(CourseTerm)`
  background: ${({ theme }) => theme.palette.gray[9]};
  padding: ${({ theme }) => theme.space.pxToRem(16)};
  p {
    margin: 0;
    padding: 0;
  }
`;
